import './DietSettings.scss';
import React from 'react';
import { UserInterview } from '../../../molecules/UserInterview/UserInterview';

export const DietSettings: React.FC = () => {
	return <UserInterview mode="diet-settings" />;
};
